export default "__VITE_ASSET__fFVHniTw__"